import { create } from "zustand";
import { v4 as uuidv4 } from "uuid";

type NotificationType = "warning" | "error" | "info" | "success";

interface Notification {
  id: string;
  title: string;
  description: string;
  type: NotificationType;
  scope: string;
  buttonTitle?: string;
  onClick?: () => void;
}

interface Notifications {
  notificationMessage: string | null;
  setNotificationMessage: (message: string | null) => void;
  notificationMessages: Notification[];
  setNotificationMessages: (messages: Notification[]) => void;
  addNotificationMessage: (
    title: string,
    description: string,
    type: NotificationType,
    scope: string,
    buttonTitle?: string,
    onClick?: () => void
  ) => void;
  fetchNotificationMessages: () => void;
  getNotificationsByScope: (scope: string) => Notification[];
  loading: boolean;
  setLoading: (loading: boolean) => void;
  resetNotifications: () => void;
}

const useNotifications = create<Notifications>()((set, get) => ({
  notificationMessage: null,
  setNotificationMessage: (message) => set({ notificationMessage: message }),

  notificationMessages: [],
  setNotificationMessages: (messages) =>
    set({ notificationMessages: messages }),

  addNotificationMessage: (
    title,
    description,
    type,
    scope,
    buttonTitle,
    onClick
  ) =>
    set((state) => ({
      notificationMessages: [
        ...state.notificationMessages,
        {
          id: uuidv4(),
          title,
          description,
          type,
          scope,
          buttonTitle,
          onClick,
        },
      ],
    })),

  loading: false,
  setLoading: (loading) => set({ loading }),

  resetNotifications: () => set({ notificationMessages: [] }),

  fetchNotificationMessages: async () => {
    set({ loading: true });
    try {
      set({ notificationMessages: [] });
      const fetchedMessages: Notification[] = [
        {
          id: uuidv4(),
          title: "Overdue Invoice",
          description: "Your invoice is overdue by 5 days.",
          type: "warning",
          scope: "exampleNotification",
          buttonTitle: "View Invoice",
          onClick: () => console.log("Invoice Clicked!"),
        },
        /* {
          id: uuidv4(),
          title: "General Notification",
          description:
            "Lorem Ipsum has been the industry's standard dummy text since the 1500s.",
          type: "info",
          scope: "generalNotification",
        }, */
      ];
      fetchedMessages.forEach((message) => {
        set((state) => ({
          notificationMessages: [...state.notificationMessages, message],
        }));
      });
    } catch (error) {
      console.error("Error fetching notification messages:", error);
    } finally {
      set({ loading: false });
    }
  },

  getNotificationsByScope: (scope) =>
    get().notificationMessages.filter((message) => message.scope === scope),
}));

export default useNotifications;
